/**
 * localStorage / sessionStorage 包装。
 */
const TOKEN_KEY = 'forum_token'
const TOKEN_EXPIRE_KEY = 'forum_token_expire'
const USER_INFO_KEY = 'forum_user_info'

export const storage = {
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY)
  },
  setToken(token: string, expiresAt: number) {
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(TOKEN_EXPIRE_KEY, String(expiresAt))
  },
  clearToken() {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(TOKEN_EXPIRE_KEY)
  },
  isTokenExpired(): boolean {
    const exp = localStorage.getItem(TOKEN_EXPIRE_KEY)
    if (!exp) return true
    return Number(exp) <= Date.now()
  },

  getUserInfo<T = unknown>(): T | null {
    const raw = sessionStorage.getItem(USER_INFO_KEY)
    if (!raw) return null
    try {
      return JSON.parse(raw) as T
    } catch {
      return null
    }
  },
  setUserInfo<T>(info: T) {
    sessionStorage.setItem(USER_INFO_KEY, JSON.stringify(info))
  },
  clearUserInfo() {
    sessionStorage.removeItem(USER_INFO_KEY)
  },
}
